export default "__VITE_ASSET__DGqRerLP__"